const PROVIDED_SEARCH_FILTER_IS_NOT_A_FUNCTION_MESSAGE = 'Provided search filter is NOT a function';

const validateType = searchFilter => {
  if (!Boolean(searchFilter)) {
    return false;
  }
  if (typeof searchFilter !== 'function') {
    throw new Error(PROVIDED_SEARCH_FILTER_IS_NOT_A_FUNCTION_MESSAGE);
  }
  return true;
};

//TODO: validate function content

export default {
  validateType
};